import styled from 'styled-components';

export const BreadcrumbContainer = styled.nav`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-xxs);
  width: 100%;
  max-width: 100%;
  margin-block: var(--space-l);
  padding: 0 0 var(--space-s) 0;
  background: transparent;
`;

export const EachBreadcrumb = styled.div`
  display: inline-flex;
  align-items: center;
  min-width: 0;

  span {
    display: inline-flex;
    align-items: center;
    max-width: 240px;

    color: ${({ variant }) =>
      variant === 'light' ? 'rgba(255,255,255,0.72)' : 'var(--grey4)'};

    font-size: 0.84rem;
    font-weight: 650;
    line-height: 1.2;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    transition: color 0.2s ease;
  }

  span:not(.current) {
    cursor: pointer;
  }

  span:not(.current):hover {
    color: ${({ variant }) =>
      variant === 'light' ? 'var(--white)' : 'var(--orange5)'};
  }

  .current {
    color: ${({ variant }) =>
      variant === 'light' ? 'var(--white)' : 'var(--grey7)'};

    font-weight: 750;
  }

  .breadcrumb-icon {
    margin-inline: var(--space-xxs);
    font-size: 0.7rem;

    color: ${({ variant }) =>
      variant === 'light' ? 'rgba(255,255,255,0.45)' : 'var(--grey2)'};

    flex: 0 0 auto;
  }
`;
